module.exports = __webpack_public_path__ + "img/emoji_51.1ebf0840.png";